import React from "react";
import {Input, InputNumber, Switch, Select, Form, Tag} from "antd";

import {IAudienceTagDetails, IAudienceTagInstanceDetails} from "@Models/ILicenseDetails";
import InspectorInfoField from "@Components/groups/InspectorInfoField";
import TickIcon from "@Components/shared/TickIcon";
import CrossIcon from "@Components/shared/CrossIcon";

interface IProps {
    tag?: IAudienceTagDetails;
    instance: IAudienceTagInstanceDetails;
    handleChange: (instance: IAudienceTagInstanceDetails, values: unknown[]) => Promise<void>;
    editable: boolean;
}

const ModuleAudienceRow: React.FC<IProps> = ({tag, instance, handleChange, editable}: IProps) => {

    const RenderItem = (): JSX.Element[] => {
        const elements: JSX.Element[] = [];
        if (tag === null) return elements;
        switch (tag?.type) {

            default:
                elements.push(
                    editable ?
                    <Input
                        key={instance.audienceTagInstanceId+"-text"}
                        name={instance.audienceTagInstanceId+"-text"}
                        value={instance.values[0]}
                        allowClear={true}
                        onChange={e => handleChange(instance, [e.target.value])}
                    /> :
                    <InspectorInfoField>{instance.values[0]}</InspectorInfoField>
                );
                break;
            
            case "numeric":
                elements.push(
                    editable ?
                    <InputNumber
                        controls={true}
                        key={instance.audienceTagInstanceId+"-numeric"}
                        name={instance.audienceTagInstanceId+"-numeric"}
                        value={instance.values[0]}
                        onChange={val => handleChange(instance, [val.toString()])}
                    /> :
                    <InspectorInfoField>{instance.values[0]}</InspectorInfoField>
                );
                break;

            case "boolean":
                const isChecked = instance.values[0] === "true";
                elements.push(
                    editable ? (
                        <Switch
                            defaultChecked={isChecked}
                            key={instance.audienceTagInstanceId + "-boolean"}
                            checkedChildren={"Yes"}
                            unCheckedChildren={"No"}
                            onChange={(val) => handleChange(instance, [String(val)])}
                        />
                    ) : isChecked ? (
                        <TickIcon />
                    ) : (
                        <CrossIcon />
                    )
                );
                break;

            case "option":
                const singleOptions = tag.options.map(x => {
                    return {label: x, value: x};
                });
                elements.push(
                    editable ? 
                    <Select
                        key={instance.audienceTagInstanceId+"-option"}
                        defaultValue={{label: instance.values, value: instance.values}}
                        value={{label: instance.values, value: instance.values}}
                        options={singleOptions}
                        onChange={val => handleChange(instance, [val])}
                    /> :
                    <InspectorInfoField>{instance.values}</InspectorInfoField>
                );
                break;

            case "multiple":
                const multiOptions = tag?.options.map(x => {
                    return {label: x, value: x};
                });
                const values = instance.values.map(x => {
                   return {label: x, value: x};
                });
                elements.push(
                    editable ?
                    <Select
                        key={instance.audienceTagInstanceId+"-multiple"}
                        mode="multiple"
                        defaultValue={values}
                        value={values}
                        options={multiOptions}
                        onChange={val => handleChange(instance, val)}
                    /> :
                    <>{values.map(x => <Tag color={"blue"}>{x.label}</Tag>)}</>
                );
                break;
        }
        return elements;
    };

    return (
        <Form
            style={{width:"100%"}}
            key={"audience-inspector-"+tag?.audienceTagId}
            className="inspector-form"
            initialValues={{}}
        >
            <Form.Item label={tag?.label}>
                {RenderItem()}
            </Form.Item>
        </Form>
    );
};
export default ModuleAudienceRow;